import { IconProps } from "./Icons";

export const IconAvatar = ({ width = 56, height = 65 }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 56 65"
    fill="none"
  >
    <g filter="url(#filter0_ii_avatar)">
      <path
        d="M15.3125 12.5593V12.2224C15.2513 5.5769 20.5494 0.125717 27.2256 0.00321898H27.2869C34.055 -0.149904 39.6594 5.17878 39.8431 11.9468C39.9963 18.7148 34.6675 24.3191 27.8994 24.5029H27.5931C20.9475 24.5029 15.5269 19.2048 15.3431 12.5593H15.3125ZM27.5625 27.5654C12.3419 27.5654 0 38.8352 0 47.9001C0 56.965 12.3419 64.3149 27.5625 64.3149C42.7831 64.3149 55.125 56.965 55.125 47.9001C55.125 38.8352 42.7831 27.5654 27.5625 27.5654Z"
        fill="url(#paint0_linear_avatar)"
      />
    </g>
    <defs>
      <filter
        id="filter0_ii_avatar"
        x="0"
        y="0"
        width="55.125"
        height="64.3145"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="566.562" dy="12.25" />
        <feGaussianBlur stdDeviation="23.1219" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.984314 0 0 0 0 0.984314 0 0 0 0.25 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="373.625" dy="113.312" />
        <feGaussianBlur stdDeviation="61.8625" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        />
        <feBlend mode="normal" in2="effect1_innerShadow" result="effect2_innerShadow" />
      </filter>
      <linearGradient
        id="paint0_linear_avatar"
        x1="27.5625"
        y1="-5.62755"
        x2="27.5625"
        y2="76.3739"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03A1C4" />
        <stop offset="0.47" stopColor="#683B97" />
        <stop offset="0.968322" stopColor="#03A1C4" />
      </linearGradient>
    </defs>
  </svg>
);
